import React, { memo, useEffect, useMemo, useState } from 'react'
import Particles, { initParticlesEngine } from '@tsparticles/react'
import { type ISourceOptions } from '@tsparticles/engine'
import { loadSlim } from '@tsparticles/slim'

import * as style from './style.module.sass'

// 再レンダリングによってpartilcesの位置が変わってしまうためmemo化
const ArtisanBackground: React.FC = memo(() => {
  const [init, setInit] = useState(false)

  useEffect(() => {
    initParticlesEngine(async engine => {
      await loadSlim(engine)
    }).then(() => {
      setInit(true)
    })
  }, [])

  const options: ISourceOptions = useMemo(
    () => ({
      fpsLimit: 30,
      detectRetina: true,
      background: {
        color: {
          value: '#FFFFFF',
        },
      },
      manualParticles: [
        {
          position: {
            x: 90,
            y: 10,
            mode: 'percent',
          },
          options: {
            color: {
              value: '#DFDAF0',
            },
            size: {
              value: 400,
            },
          },
        },
        {
          position: {
            x: 20,
            y: 70,
            mode: 'percent',
          },
          options: {
            color: {
              value: '#BDBAC4',
            },
            size: {
              value: 300,
            },
          },
        },
        {
          position: {
            x: 90,
            y: 90,
            mode: 'percent',
          },
          options: {
            color: {
              value: '#BFBFBF',
            },
            size: {
              value: 200,
            },
          },
        },
      ],
      particles: {
        move: {
          enable: true,
          random: false,
          speed: 10,
          straight: false,
        },
      },
    }),
    [],
  )

  if (!init) {
    return <div className={style.background} />
  }

  return (
    <div className={style.background} data-loaded={true}>
      <Particles options={options} />
    </div>
  )
})

export default ArtisanBackground
